import styled from 'styled-components';

import { Button } from '../';

const Actions = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    height: 85px;

    > ${Button} {
        margin-left: 2em;
        border: 2px ${(props) => props.theme.primary} solid;
    }
`;

const ActionsMobile = styled(Actions)`
    display: grid;
    align-items: center;
    height: 8em;
    margin-top: 1.5em;
    margin-bottom: 1em;
    width: initial;

    @media (min-width: ${(props) => props.theme.mobileLimit}) {
        display: none;
    }
`;

export { Actions, ActionsMobile };
